import moment from 'moment-timezone';

import { ERegionCode } from '../../interfaces';
import { MATURE_DRIVER_STATES_CONFIG } from '../constants/regionConfigs';

type TCalculateDriverAge = {
  effectiveDate: string;
  dob: string;
};

export function calculateDriverAge({
  effectiveDate,
  dob,
}: TCalculateDriverAge) {
  const dobWithoutGracePeriod = moment.utc(effectiveDate).diff(dob, 'years');
  const dobWithGracePeriod = moment(dob).subtract(30, 'days');
  const calculatedDriverAge =
    dobWithoutGracePeriod < 25
      ? moment.utc(effectiveDate).diff(dobWithGracePeriod, 'years')
      : dobWithoutGracePeriod;

  return calculatedDriverAge;
}

export type TGetDriverAgeConfig = {
  regionCode: ERegionCode;
  effectiveDate: string;
  dob: string;
  driverAge?: number;
};

export function getDriverAgeConfig({
  regionCode,
  effectiveDate,
  dob,
  driverAge,
}: TGetDriverAgeConfig) {
  const matureDriverConfig = MATURE_DRIVER_STATES_CONFIG.find(
    ({ region }) => region === regionCode
  );

  const driverCompareAge = calculateDriverAge({ effectiveDate, dob });

  const is18orYounger = driverCompareAge < 19;

  const isYoungerThan23 = dob.length === 10 ? driverCompareAge < 23 : false;
  const isMature =
    matureDriverConfig && dob.length === 10
      ? (driverAge || driverCompareAge) >= matureDriverConfig.age
      : false;

  return {
    is18orYounger,
    isYoungerThan23,
    isMature,
    driverAge: driverCompareAge,
  };
}
